<h1>{{ 'ADMIN.DASHBOARD.TITLE' | translate }}</h1>

<a class="btn btn-primary mb-3" 
    routerLink="/admin/users" 
    routerLinkActive="active" 
    [routerLinkActiveOptions]="{ exact: false }" >
    {{ 'ADMIN.DASHBOARD.VIEW_USERS' | translate }}
</a>